import {
  FETCH_APPOINTMENTLIST_REQUEST,
  FETCH_APPOINTMENTLIST_SUCCESS,
  FETCH_APPOINTMENTLIST_FAILURE,
} from "./appointmentListTypes";

const initialState = {
  loading: false,
  appointmentList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APPOINTMENTLIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_APPOINTMENTLIST_SUCCESS:
      return {
        loading: false,
        appointmentList: action.payload,
        error: "",
      };
    case FETCH_APPOINTMENTLIST_FAILURE:
      return {
        loading: false,
        appointmentList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
